import { render, staticRenderFns } from "./ClaimProductInfo.vue?vue&type=template&id=69d8bd9f&scoped=true"
import script from "./ClaimProductInfo.vue?vue&type=script&lang=js"
export * from "./ClaimProductInfo.vue?vue&type=script&lang=js"
import style0 from "./ClaimProductInfo.vue?vue&type=style&index=0&id=69d8bd9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d8bd9f",
  null
  
)

export default component.exports